import React from "react";
import FadeInSection from "./FadeInSection";

const Credits = () => (
    <footer className="border-t border-line">
        {/* Extra bottom room on phones so the floating resume button doesn't
            land on top of the credit line. */}
        <div className="shell py-10 pb-24 sm:py-12 sm:pb-12">
            <FadeInSection>
                <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:justify-between sm:text-left">
                    <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-ink-faint">
                        Crafted by Gayashan Hansaja
                    </p>
                    <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-ink-faint">
                        © {new Date().getFullYear()} — All rights reserved
                    </p>
                </div>
            </FadeInSection>
        </div>
    </footer>
);

export default Credits;
